// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2ADwh","head":"ProcedureTableInfo_head__1Z-Vz"};